import React from "react";
import SqueletonCss from "./SqueletonPlaceholder.module.css";

export default function SqueletonPlaceholder({
  height = "8px",
}: {
  height?: string;
}) {
  return (
    <div
      className={SqueletonCss.animated__background}
      style={{ height: height }}
    ></div>
  );
}
